// composables
import { useI18n } from '#i18n';

export default function useLangT(lang?: string) {
  const { t, locale } = useI18n();

  return (key: string, slots: Record<string, unknown> = {}) => {
    return t(key, slots, {
      locale: lang || locale.value,
    });
  };
}
